import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { TABLE_DATA, TABLE_STRUCTURE } from 'src/app/core/config/config.constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TableService {
  private baseUrl: string = environment.baseTsOhwUrl;

  constructor(private _httpClient: HttpClient) { }

  getTableData(command: any): Observable<any> {
    return this._httpClient.post(`${this.baseUrl}${TABLE_DATA}`, command);
  }

  getTableColumns(tableType: string): Observable<any> {
    return this._httpClient.get(`${this.baseUrl}${TABLE_STRUCTURE}?table_type=${tableType}`);
  }

}